import { isAuthenticated } from "../Auth/auth";
export const hasPermission = (permissions, module, permissionType, routes) => {
  const user = isAuthenticated();
  if (user?.role === 2) {
    return true;
  } else {
    const moduleLower = module?.toLowerCase();
    // Everyone may open their own profile and chat. Route guards pass the path segment ("profile"),
    // so this has to ignore case, and it must not depend on the user having a role at all.
    if (moduleLower === "profile" || moduleLower === "chat" || moduleLower === "chats") return true;
    if (!permissions) return false;
    return permissions?.some(permissionObj => {
      const modulePermissions = Object.keys(permissionObj).find(
        key => key?.toLowerCase() === moduleLower
      );
      if (module === "Profile" || (routes && module === "Projects")) {
        return true;
      }
      if (modulePermissions) {
        const permissionsArray = permissionObj[modulePermissions];
        return Array.isArray(permissionsArray) && permissionsArray.includes(permissionType);
      }
      return false;
    });
  }
};
